import { useContext, useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css";
import Loader from "../Loader/Loader";
import ReactQuill from "react-quill";
import { getTermsAndConditions, updateTermsAndConditions, createTermsAndConditions } from "../../webServices/Apis";
import { message } from "antd";
import { useNavigate } from "react-router";
import { UserContext } from "../../App";

const TermsAndCondition = () => {
  const navigate = useNavigate();
  const { setIsAuthenticated } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [text, setText] = useState("");
  const [disableStatus, setDisableStatus] = useState(true);

  // Fetch Terms and Conditions from API
  const getTermsAndConditionApi = async () => {
    setLoading(true);
    try {
      const response = await getTermsAndConditions();
      if (response?.data?.success) {
        const termsData = response?.data?.data[0];
        setData(termsData);
        setText(termsData?.content || "");
      }
    } catch (error) {
      console.error("Error fetching terms and conditions:", error);
      if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert("Your account is logged in to another device, please login again !")
        localStorage.removeItem('token');
        setIsAuthenticated(false)
        window.location.href = "/login";
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding")
        return;
      }
      if (error?.response?.status === 403) {
        window.alert("Your subcription has been expired")
        localStorage.clear()
        setIsAuthenticated(false)
        window.location.href = "/login";
      }
      else {
        // message.error(error?.response?.data?.message)
        return;
      }

    } finally {
      setLoading(false);
    }
  };

  // Create Terms and Conditions
  const createTermsAndConditionsApi = async () => {
    setLoading(true);
    try {
      const response = await createTermsAndConditions({ content: text });
      if (response?.data?.success) {
        message.success(response?.data?.message);
        await getTermsAndConditionApi();
      }
    } catch (error) {
      console.error("Error creating terms and conditions:", error);
      message.error(error?.response?.data?.message || "Error in creating terms and conditions");
    } finally {
      setLoading(false);
    }
  };

  // Update Terms and Conditions
  const updateTermsAndConditionsApi = async () => {
    setLoading(true);
    try {
      const response = await updateTermsAndConditions(data.id, { content: text });
      if (response?.data?.success) {
        message.success(response?.data?.message);
        setDisableStatus(true);
      }
    } catch (error) {
      console.error("Error updating terms and conditions:", error);
      message.error("Error while updating terms and conditions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTermsAndConditionApi();
  }, []);

  // Handle content change in ReactQuill editor
  const handleChange = (value) => {
    setText(value);
    setDisableStatus(false); // Enable button when content changes
  };

  return (
    <>
      <div style={{ width: "90%", margin: "0px auto" }}>
        <div style={{ marginTop: "100px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
            <h1 style={{ fontSize: "22px", fontWeight: 600 }}>Terms and Conditions</h1>
            {loading && <Loader />}
          </div>
          <ReactQuill
            value={text}
            onChange={handleChange}
            placeholder="Write your terms and conditions here..."
            theme="snow"
            className="mb-4"
            style={{ height: "300px" }}
          />
        </div>
      </div>
      <div className="flex flex-row justify-end items-center w-full">
        <button
          onClick={data?.id ? updateTermsAndConditionsApi : createTermsAndConditionsApi}
          disabled={disableStatus}
          style={{
            backgroundColor: disableStatus ? "grey" : "blue",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "10px",
            marginTop: "60px",
            marginRight: "80px",
          }}
        >
          {data?.id ? "Update Terms and Conditions" : "Create Terms and Conditions"}
        </button>
      </div>
    </>
  );
};

export default TermsAndCondition;

